module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-9-2ccaebc076b7fe2c989cbf430a21a9cd.webp";